import { GetMeDocument, type GetMeQuery, type GetMeQueryVariables } from "~/common/gqls";
import type { Tenant, User } from "~/common/types";
import { config } from "~/config";
import { type AuthenticatedFetch, getClientWithAuthenticatedFetch } from "~/lib/apolloClient";

export class UnregisteredUserError extends Error {}

export const loadAuthenticatedUser = async (authenticatedFetch: AuthenticatedFetch): Promise<User> => {
  // Cnut exposes cnutGetMe through Hasura's remote schema, so Dewey keeps this on its normal GraphQL route.
  const client = getClientWithAuthenticatedFetch(authenticatedFetch);
  const userResult = await client.query<GetMeQuery, GetMeQueryVariables>({
    query: GetMeDocument,
  });
  const apiUser = userResult.data?.cnutGetMe;
  if (apiUser?.__typename !== "UserMeOutput") {
    throw new UnregisteredUserError("User is not registered");
  }
  if (apiUser.roles.length > 1) {
    throw new Error("cnutGetMe returned multiple product roles");
  }

  const tenants: Tenant[] = apiUser.tenants.map(({ id, shortCode }) => ({ id, shortCode }));
  if (!tenants.some(({ shortCode }) => shortCode === "rollo")) {
    tenants.push({ id: config.rolloTenantId, shortCode: "rollo" });
  }

  return {
    id: apiUser.id,
    email: apiUser.email,
    displayName: apiUser.displayName ?? null,
    photoURL: null,
    role: apiUser.roles[0] ?? "",
    tenants,
  };
};
